import React, { Component } from 'react'
import "../../css/general-style.css"
import styles from '../../css/PriceListModal.module.css';
import { AiFillPrinter } from "react-icons/ai"
import Select from 'react-select';
import DashModalV2 from '../DashModalV2'
import { getIndexElement } from '../../functions/searchInObject'
import { getInformationWithData } from '../../services/CABE';
import { getValueCookie } from '../../services/cookieService';
import { PriceList } from './PriceList';
import { getPrintHeaderCompany } from '../../functions/companyInformation';
import LoadingWindow from '../../components/LoadingWindow';
import { FormatQueryReturnDateForReport, getActualDateUTC, getDateFromReports } from '../../functions/dateFormat';
import { pricesFormat } from '../../functions/pricesFormat';
import ExcelDocument from '../ExcelDocument';
import { getDataSet } from '../../functions/generateDataSetExcel';

export class PriceListModal extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }

    state = {
        showModal: false,
        lastRow: 0,
        companyPrintHeader: getPrintHeaderCompany(),
        selectOptions: [
            { value: 1, label: 'Price Level 1' },
            { value: 2, label: 'Price Level 2' },
            { value: 3, label: 'Price Level 3' }
        ],
        PriceLevel: 1,
        ProductLines: [],
        ProductsFilter: [],
        ProductsList: [],
        selectedAllProdLines: true,
        Customer: ''

    }
    handleModalOpen = async () => {
        await this.GetProducts()
        await this.setState({ showModal: true })
    }

    handleModalClose = () => {
        this.setState({ showModal: false })
    }
    onChangeSelects = async (e, id) => {

        switch (id) {
            case "PriceLevel":
                this.setState({ PriceLevel: e.value })
                break;
            default:
                break;
        }
        await this.GetProducts()


    }
    async GetProducts() {
        await this.ModalLoading.current.showState(true);
        const data = {
            company: getValueCookie('Company'),
            idcompany: getValueCookie('CompanyId'),
            priceLevel: this.state.PriceLevel,
            Component: null
        }
        const respuesta = await getInformationWithData('/Items/get', data);
        if (getValueCookie('CompanyId') === '6') {
            data.company = 'Mayaland Atlanta'
            data.idcompany = '3'
            const respuesta2 = await getInformationWithData('/Items/get', data);

            if (getValueCookie('CompanyId') === '6' && data.priceLevel !== '2') {
                for (const item of respuesta2.data) {

                    if (item.UnitPriceALT || item.UnitPriceALT !== 0) {
                        //751096

                        //let p = item.LastTotalUnitCost / (0.95)
                        //item.UnitPrice = Number(pricesFormat(p / (0.65)))
                        item.UnitPrice = Number(pricesFormat(item.UnitPriceALT))

                    } else {
                        //ELIMINAR DEL CATALOGO
                        console.log(item.itemCode)

                    }
                }

            }
            respuesta.status.code = respuesta2.status.code
            //respuesta.data = respuesta.data.concat(respuesta2.data)
            for (const item of respuesta2.data) {
                item.IdCompany = 3
                const index = getIndexElement(respuesta.data, 'itemCode', item.itemCode)
                if (index !== -1) {
                    await respuesta.data.splice(index, 1)
                }
            }
            for (const item of respuesta.data) {
                item.IdCompany = 6
                if (item.UnitPriceALT || item.UnitPriceALT !== 0) {
                    item.UnitPrice = Number(pricesFormat(item.UnitPriceALT))
                }
            }

            respuesta.data = respuesta.data.concat(respuesta2.data)
        }


        let ProductLines = []
        for (const iterator of respuesta.data) {
            const index = getIndexElement(ProductLines, 'label', iterator.ProductLineDesc)
            if (index === -1) {
                ProductLines.push({ label: iterator.ProductLineDesc, selected: true })
            }
        }
        if (getValueCookie('CompanyId') === '6') {
            for (const item of respuesta.data) {
                console.log(item)
                if (item.UnitPriceALT || item.UnitPriceALT !== 0) {
                    item.UnitPrice = Number(pricesFormat(item.UnitPriceALT))
                }
            }
        }


        await this.setState({ ProductLines: ProductLines, ProductsList: respuesta.data, ProductsFilter: respuesta.data, selectedAllProdLines: true })
        await this.ModalLoading.current.showState(false);
    }
    checkAllInv = async (e, actualStat) => {
        const temporal = this.state.ProductLines

        if (!actualStat) {
            temporal.forEach(element => {
                element.selected = true
            })

            await this.setState({ ProductLines: temporal, selectedAllProdLines: true })
        } else {
            temporal.forEach(element => {
                element.selected = false
            })

            await this.setState({ ProductLines: temporal, selectedAllProdLines: false })
        }

    }

    viewSelectedAll() {
        let temporal = true
        for (const iterator of this.state.ProductLines) {
            if (!iterator.selected) {
                temporal = false
                break
            }
        }
        this.setState({ selectedAllProdLines: temporal })
    }
    checkSpecificProdLine = async (e, actualStat, ProdLine) => {
        const temporal = this.state.ProductLines
        const index = getIndexElement(temporal, 'label', ProdLine)
        if (index !== -1) {
            temporal[index].selected = !actualStat
        }
        await this.setState({ ProductLines: temporal })
        await this.viewSelectedAll()
    }

    onChange = e => {
        this.setState({ Customer: e.target.value })
    }

    getPrintProducts() {

        if (this.state.selectedAllProdLines) {
            let items = []
            for (const item of this.state.ProductsList) {
                item.abbreviatedDesc = (item.completeDesc && item.completeDesc !== "null") ? item.completeDesc : item.abbreviatedDesc
                items.push(item)
            }
            return items
        } else {
            let ProdLines = []
            for (const ProdLine of this.state.ProductLines) {
                if (ProdLine.selected) {
                    ProdLines.push({ label: ProdLine.label })
                }
            }
            let items = []
            for (const item of this.state.ProductsList) {
                const index = getIndexElement(ProdLines, 'label', item.ProductLineDesc)
                if (index !== -1) {
                    item.abbreviatedDesc = (item.completeDesc && item.completeDesc !== "null") ? item.completeDesc : item.abbreviatedDesc
                    items.push(item)
                }
            }

            return items


        }
    }



    render() {
        const labelStyle = {
            fontSize: '0.75rem', fontWeight: 700, color: '#64748B',
            textTransform: 'uppercase', letterSpacing: '0.4px',
            display: 'block', marginBottom: '6px',
        };
        const sectionTitle = {
            fontSize: '0.75rem', fontWeight: 700, color: '#64748B',
            textTransform: 'uppercase', letterSpacing: '0.6px',
            borderBottom: '1px solid #E2E8F0', paddingBottom: '6px', marginBottom: '12px',
        };

        return (
            <React.Fragment>
                <LoadingWindow ref={this.ModalLoading} />

                {/* Trigger button */}
                <button
                    hidden={this.props.hidden}
                    id={this.props.id}
                    disabled={this.props.disabled}
                    type="button"
                    onClick={() => this.handleModalOpen()}
                    style={{
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 100%)',
                        border: 'none', borderRadius: '10px', color: 'white',
                        padding: '0 1.25rem', fontWeight: 600, fontSize: '0.875rem',
                        cursor: 'pointer', display: 'flex', alignItems: 'center',
                        gap: '0.4rem', height: '100%', whiteSpace: 'nowrap',
                    }}
                >
                    <AiFillPrinter /> {this.props.titleButton}
                </button>

                {/* Modal */}
                <DashModalV2
                    title="Print Price Levels"
                    subtitle="Generate and export a price list by level"
                    show={this.state.showModal}
                    onClose={() => this.handleModalClose()}
                    size="xl"
                    footer={
                        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
                            <PriceList
                                id={"PriceListPrint"}
                                colorButton="blueButton"
                                title="Price Level List"
                                companyLogo={getValueCookie('DocumentsLogo')}
                                OrderTitle="Items Price List"
                                contactInfo={this.state.companyPrintHeader}
                                OrderInfo1={["Customer: ", this.state.Customer, "Date: ", FormatQueryReturnDateForReport(getActualDateUTC()), "Print by: ", getValueCookie('userName'), "", ""]}
                                headerTable={["Item Code", "", "Product Line", "Description", "", "Unit\nPrice*"]}
                                bodyTable={this.getPrintProducts()}
                                headerBodyTable={["itemCode", "", "ProductLineDesc", "abbreviatedDesc", "dolar", "UnitPrice"]}
                                bottomInfo={[]}
                                styleColumns={["ColumnaTextoNormalLeft", "Dolar", "ColumnaTextoLargo", "ColumnaTextoLargo3", "Dolar", "ColumnaPrecios"]}
                                hidden={false}
                                comment={"*These prices may change without prior notice"}
                                breakpoint={48}
                                keysDecimalFormat={["UnitPrice"]}
                                disabled={false}
                                titleButton='Print PDF'
                            />
                            <ExcelDocument
                                hidden={false}
                                id={"ExcelPriceListData"}
                                data={getDataSet(this.getPrintProducts(), ["Item Code", "Product Line", "Description", "Unit Price"], ["itemCode", "ProductLineDesc", "abbreviatedDesc", "UnitPrice"])}
                                sheetname={"Level " + this.state.PriceLevel}
                                archname={"Price List Level " + this.state.PriceLevel + " " + getValueCookie('Company') + " DATE " + getDateFromReports()}
                            />
                        </div>
                    }
                >
                    <div className="row g-4">

                        {/* Left column: Price Level + Customer */}
                        <div className="col-md-5">
                            <p style={sectionTitle}>Configuration</p>

                            <label style={labelStyle}>Price Level</label>
                            <Select
                                value={this.state.selectOptions[getIndexElement(this.state.selectOptions, 'value', String(this.state.PriceLevel))]}
                                options={this.state.selectOptions}
                                onChange={(e) => this.onChangeSelects(e, "PriceLevel")}
                                placeholder="Select Price Level"
                                styles={{
                                    control: (base) => ({ ...base, borderRadius: '8px', border: '1.5px solid #E2E8F0', fontSize: '0.9375rem' }),
                                }}
                            />

                            <label style={{ ...labelStyle, marginTop: '16px' }}>Customer (optional)</label>
                            <input
                                onChange={this.onChange}
                                id='CustomerOfListPriceReport'
                                type="text"
                                autoComplete='off'
                                placeholder="Customer name for the header…"
                                style={{
                                    width: '100%', padding: '0.625rem 0.875rem',
                                    border: '1.5px solid #E2E8F0', borderRadius: '8px',
                                    fontSize: '0.9375rem', outline: 'none',
                                }}
                                onFocus={e => e.target.style.borderColor = '#2563EB'}
                                onBlur={e => e.target.style.borderColor = '#E2E8F0'}
                            />
                        </div>

                        {/* Right column: Product Lines */}
                        <div className="col-md-7">
                            <p style={sectionTitle}>Product Lines</p>

                            {/* All toggle */}
                            <div style={{ marginBottom: '12px' }}>
                                <button
                                    type="button"
                                    onClick={(e) => this.checkAllInv(e, this.state.selectedAllProdLines)}
                                    style={{
                                        padding: '5px 14px', borderRadius: '999px', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer',
                                        border: '1.5px solid',
                                        borderColor: this.state.selectedAllProdLines ? '#2563EB' : '#E2E8F0',
                                        background: this.state.selectedAllProdLines ? '#EFF6FF' : '#F8FAFC',
                                        color: this.state.selectedAllProdLines ? '#1e40af' : '#64748B',
                                    }}
                                >
                                    {this.state.selectedAllProdLines ? '✓ All Product Lines' : 'All Product Lines'}
                                </button>
                            </div>

                            {/* Product line pills */}
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', maxHeight: '280px', overflowY: 'auto', padding: '2px' }}>
                                {this.state.ProductLines.map((element, e) => (
                                    <button
                                        key={e}
                                        type="button"
                                        onClick={(ev) => this.checkSpecificProdLine(ev, element.selected, element.label)}
                                        style={{
                                            padding: '4px 12px', borderRadius: '999px', fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer',
                                            border: '1.5px solid',
                                            borderColor: element.selected ? '#2563EB' : '#E2E8F0',
                                            background: element.selected ? '#EFF6FF' : '#F8FAFC',
                                            color: element.selected ? '#1e40af' : '#94A3B8',
                                            transition: 'all 0.15s',
                                        }}
                                    >
                                        {element.selected ? '✓ ' : ''}{element.label}
                                    </button>
                                ))}
                            </div>
                        </div>

                    </div>
                </DashModalV2>

            </React.Fragment>
        );
    }
}

